export default {
  historyRow1: '杰为软件成立于2007年，持续与中国拥有最高合作标准的部分制造商往来，后成为中国最大的PLM软件实施商。 倾听客户需求，了解业务次序，杰为意识到数字化转型成为制造公司的前进方向，却又在很大程度上受制于传统的系统。 2016年，我们采用现代化技术，开始构建全新的工业软件平台。',
  historyRow2: '杰为团队致力于在客户成功，继续交付一流业务解决方案，为客户提供可以量化的成果和价值。',
  historyRow3: '杰为成立伊始',
  historyRow4: '企业级的服务',
  historyRow5: '最大PLM服务商',
  historyRow6: '与PLM China合并',
  historyRow7: '向软件公司转型',
  historyRow8: '发布杰为工业软件平台',
  historyRow9: '发布IIOT，质量及设计导航产品',
  historyRow10: '发布Digital PPM, MPM and NPI ',
  historyRow11: '',
  historyRow12: ''
}
